export const sidebarContent: any[] = [
  {
    label: 'Dashboard',
    iconClass: 'dashboardIcon',
    route: '/dashboard',
    permissionKey: 'dashboardMenu',
    hoverKey: 'dashboard',
    routerLinkActive: 'dashboardIconActive',
    routerLinkActiveOptions: { exact: false },
  },
  {
    label: 'People',
    iconClass: 'peopleIcon',
    route: '/people',
    permissionKey: 'peopleMenu',
    hoverKey: 'people',
    routerLinkActive: 'peopleIconActive',
    routerLinkActiveOptions: { exact: false },
  },
  {
    label: 'Helpers',
    iconClass: 'helpersIcon',
    route: '/helper-all',
    permissionKey: 'helpersMenu',
    hoverKey: 'helpers',
    routerLinkActive: 'helpersIconActive',
    routerLinkActiveOptions: { exact: false },
  },
  {
    label: 'Questionnaires',
    iconClass: 'questionnairesIcon',
    route: '/questionnaire',
    permissionKey: 'questionnaireMenu',
    hoverKey: 'questionnaire',
    routerLinkActive: 'questionnairesIconActive',
    routerLinkActiveOptions: { exact: false },
  },
  {
    label: 'Insights',
    iconClass: 'insightsIcon',
    route: '/insights',
    permissionKey: 'insightsMenu',
    hoverKey: 'insights',
    routerLinkActive: 'insightsIconActive',
    routerLinkActiveOptions: { exact: false },
  },
  {
    label: 'Settings',
    iconClass: 'settingsIcon',
    route: '/settings',
    permissionKey: 'settingsMenu',
    hoverKey: 'settings',
    routerLinkActive: 'settingsIconActive',
    queryParams: { tab: 'Helpers' },
    onClick: 'settingsClick',
    routerLinkActiveOptions: {
      queryParams: 'ignored',
      matrixParams: 'exact',
      paths: 'subset',
      fragment: 'exact',
    },
  },
];
